import imageUrlBuilder from '@sanity/image-url';
import { ImageLoader } from 'next/image';
// import client from '@data/sanityClient';
// import {ResolvedImageData} from '@data/types';

// const getContentfulFullImageUrl = (
//     src: string,
//     filetype?: string,
//     fit?: string,
//     width?: number,
//     height?: number,
//     quality?: number,
//   ): string => {
//   if (src.startsWith('//images.ctfassets.net')) {
//     console.log('width', width);
//     const url = new URL(`https:${src}`)
//     { filetype && url.searchParams.set('fm', filetype) }
//     { fit && url.searchParams.set('fit', fit) }
//     { width && url.searchParams.set('w', width.toString()) }
//     { height && url.searchParams.set('h', height.toString()) }
//     { quality && url.searchParams.set('q', quality.toString()) }
//     return url.href
//   }
//   console.log('src is not a contentful image');
//   return '';
// };

// Docs: https://www.contentful.com/developers/docs/references/images-api/
export const contentfulNextImageLoader: ImageLoader = ({ src, quality, width }) => {
  const url = new URL(src);
  url.searchParams.set('fm', 'jpg');
  url.searchParams.set('w', width.toString() || '1600px'); // 1600px is the max width of the body
  url.searchParams.set('q', quality?.toString() || '90');
  return url.href;
};

export const getAspectRatioFromImageData = (
  //img: ResolvedImageData,
  img: any,
  opts?: { ignoreCrop?: boolean },
) => {
  if (img.crop && !opts?.ignoreCrop) {
    // crops are specified as a fraction of total width or height from named edge
    const w = Math.abs(1 - img.crop.right - img.crop.left);
    const h = Math.abs(1 - img.crop.bottom - img.crop.top);
    return w / h;
  }
  const w = img.asset.metadata.dimensions.width;
  const h = img.asset.metadata.dimensions.height;
  return w / h;
};

// export default getContentfulFullImageUrl;
